import { RefObject, useCallback, useRef } from 'react';

interface UseInfiniteScrollSentinelParams {
  onReachEnd: () => void;
  rootRef?: RefObject<HTMLElement | null>;
}

const SENTINEL_ROOT_MARGIN = '120px';

const useInfiniteScrollSentinel = ({
  onReachEnd,
  rootRef,
}: UseInfiniteScrollSentinelParams): ((node: HTMLDivElement | null) => void) => {
  const observerRef = useRef<IntersectionObserver | null>(null);

  return useCallback(
    (node: HTMLDivElement | null): void => {
      observerRef.current?.disconnect();
      observerRef.current = null;

      if (!node || typeof IntersectionObserver === 'undefined') {
        return;
      }

      observerRef.current = new IntersectionObserver(
        ([entry]) => {
          if (entry?.isIntersecting) {
            onReachEnd();
          }
        },
        { root: rootRef?.current ?? null, rootMargin: SENTINEL_ROOT_MARGIN },
      );
      observerRef.current.observe(node);
    },
    [onReachEnd, rootRef],
  );
};

export default useInfiniteScrollSentinel;
